import { ButtonType, UpdateFacetOnModelMessage, LineStrip, MetaDataBase, HighlightLineStrip, MetaDataFacet } from "flavr-common";
import { InteractionHandler } from "../../Interactions";
import { SetControllerButtonDescription } from "../../../../messages/controller/ControllerMessages";
class HiglightLineStripMetaData extends MetaDataBase {
    constructor(highlight) {
        super();
        this.highlight = highlight;
    }
}
HiglightLineStripMetaData.typestatic = "HiglightLineStrip";
export class HighlightLineStripInteractionHandler extends InteractionHandler {
    constructor(metaDataMgr) {
        super(HighlightLineStrip.typestatic, [HighlightLineStrip.typestatic], [], []);
        this.metaDataMgr = metaDataMgr;
    }
    onSelect(params, uid, controller) {
        if (!HighlightLineStrip.is(params))
            return;
        const metaData = this.metaDataMgr.getMetaData(uid, HiglightLineStripMetaData);
        const highlight = metaData && metaData.highlight;
        this.connection.send(new SetControllerButtonDescription(ButtonType.SELECT, highlight ? "Markierung aufheben" : "Line markieren", controller.uid));
        if (!highlight) {
            this.connection.send(new UpdateFacetOnModelMessage(uid, new LineStrip(params.points, params.selected.color, params.selected.thickness, params.selected.fussyness, params.selected.noiseFreqeuncy, params.selected.noiseVelocity)));
        }
    }
    onSelectButtonClick(params, uid) {
        if (!HighlightLineStrip.is(params))
            return;
        const metaData = this.metaDataMgr.getMetaData(uid, HiglightLineStripMetaData);
        const wasHighlighted = metaData && metaData.highlight;
        const isHighlighted = !wasHighlighted;
        this.connection.send(new UpdateFacetOnModelMessage(uid, new MetaDataFacet(new HiglightLineStripMetaData(isHighlighted))));
        const lineParmas = isHighlighted ? params.highlighted : params.selected;
        const lineStrip = new LineStrip(params.points, lineParmas.color, lineParmas.thickness, lineParmas.fussyness, lineParmas.noiseFreqeuncy, lineParmas.noiseVelocity);
        this.connection.send(new UpdateFacetOnModelMessage(uid, lineStrip));
    }
    onDeselect(params, uid, {}) {
        if (!HighlightLineStrip.is(params))
            return;
        const metaData = this.metaDataMgr.getMetaData(uid, HiglightLineStripMetaData);
        const highlight = metaData && metaData.highlight;
        if (!highlight) {
            this.connection.send(new UpdateFacetOnModelMessage(uid, new LineStrip(params.points, params.unselected.color, params.unselected.thickness, params.unselected.fussyness, params.unselected.noiseFreqeuncy, params.unselected.noiseVelocity)));
        }
    }
}
